import { applyMiddleware, createStore } from "redux";
import RootReducer from "./reducer/index";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./saga";

const sagaMiddleware = createSagaMiddleware();

export function ConfigureStore(){
    const store = createStore(RootReducer, applyMiddleware(sagaMiddleware));
    sagaMiddleware.run(rootSaga);
    return store;
}